// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"a1bd5285","347":"a1bd5285","467":"8efc6c5c"}[chunkId] + ".chunk.css";
};